<template>
	<div class="login-background">
		<div class="login-info">
			<div class="login-form-background">
				<div style="width: 100%;background: #3d4147;height: 100%;padding-top: 22%;">
					<p style="font-size: 32px;font-weight:bold;color: #3fb393;width: 100%;display: flex;justify-content: center;">{{$t('label_589')}}</p>
					<p style="font-size: 22px;color: #3fb393;font-weight:bold;width: 100%;display: flex;justify-content: center;line-height: 40px">{{$t('label_592')}}</p>
					<!-- 演示 -->
					<!-- <p style="font-size: 32px;font-weight:bold;color: #3fb393;width: 100%;display: flex;justify-content: center;">设备预防保全管理系统</p>
					<p style="font-size: 22px;color: #3fb393;font-weight:bold;width: 100%;display: flex;justify-content: center;line-height: 40px">实现全员设备维护管理</p> -->
				</div>
				<div style="height:100%;background: #ffffff;display: flex;width: 100%;justify-content: center;flex-wrap: wrap;padding-top: 80px">
					<!-- <div style="position: absolute;top: 0px;right: 0px;font-size: 18px;"> -->
            <!--NWC现场不开放-->
						<!-- <el-radio-group v-model="languages" fill="#3fb393" @change="changeLanguages">
							<el-radio-button label="1"><span>中文</span></el-radio-button>
							<el-radio-button label="2"><span>日本語</span></el-radio-button>
							<el-radio-button label="3"><span>ENG</span></el-radio-button>
						</el-radio-group>
					</div> -->
					<div style="display: flex;align-items: center;color: #000;font-size: 20px;width: 300px;margin-bottom: 32px;">
						{{$t('label_371')}}/Login
					</div>
					<div class="login-form">
						<div class="login-input">
							<input class="username" v-model="username" type="text" :placeholder="$t('label_603')" @keyup.enter="login">
						</div>
						<div class="login-input">
							<input class="password" v-model="password" type="password" :placeholder="$t('label_606')" @keyup.enter="login">
						</div>
						<div class="login-input">
							<div class="login-a" style="width: 300px;display: flex;justify-content: space-between;margin-bottom: 20px;font-size: 12px;color:#9EA5AD">
								<!-- <div>自动登录</div>
                <div>找回密码？</div> -->
							</div>
						</div>
						<div class="login-button" v-if="versions!=3">
							<button @click="login">
								{{$t('label_371')}}
							</button>
						</div>
					</div>
				</div>
			</div>
<!--      app二维码-->
      <div v-if="this.$store.getters.getDownloadAppFlag == 1"  class="right-qrcode-showbtn-background" :style="'right:' + (width) + 'px'" @click="showBtn">
        <img style="width:100%;height:100%;"
             src="../../assets/img/login/buttonLeft.png">
      </div>

		</div>
		<!--<div class="bottom-text">
      <div style="width:100%;"><a target="_blank" href="http://beian.miit.gov.cn/">苏ICP备19045513号-3</a></div>
    </div>-->

    <!--app二维码-->
    <div class="right-qrcode" v-show="qrCodeShow">
      <canvas id="appQRCode"></canvas>
      <div style="width:100%;text-align: center;">App Download</div>
    </div>
	</div>
</template>

<script>
	import Request from "@/assets/js/request/request.js";
	import utils from "@/utils/utils.js";
	import global from "@/assets/js/common/common.js";
  import QRCode from "qrcode";
  import {loadLanguageAsync} from "../../main";

  export default {
		name: 'login',
		data() {
			return {
				username: '',
				password: '',
				qrCodeShow: false,
        loading: false,
				width: '0',
				telephone: '',
				mail: '',
				address: '',
				cookie: '',
				versions: 4, //#1:THK; 2: 三菱 3郯城 4 JP、夏家河、春柳河,
				languages: '2'
			}
		},
		methods: {
      changeLanguages(){
        this.$store.commit('setLanguageName',this.languages);
        let languageType;
        if (this.languages=="1"){
          languageType = "chs";
          // loadLanguageAsync('chs')
        } else if (this.languages=="2"){
          languageType = "ja";
          // loadLanguageAsync('ja')
        } else if (this.languages=="3"){
          languageType = "en";
          // loadLanguageAsync('en')
        }
        loadLanguageAsync(languageType);
        // sessionStorage.setItem("languageType", languageType);
      },
		  showBtn() {
		    this.qrCodeShow = !this.qrCodeShow;
		    if (this.qrCodeShow) {
		      this.width = '200';
        } else {
		      this.width = '0';
        }
      },
      appQRCode() {
        let msg = document.getElementById("appQRCode");
        QRCode.toCanvas(msg, this.$store.getters.getAppDownloadURL, {
        // 春柳河
        // QRCode.toCanvas(msg, "http://116.204.126.66:8101/app/device.apk", {
        // 夏家河
        // QRCode.toCanvas(msg, "http://116.204.126.66:8201/app/device.apk", {
        // QRCode.toCanvas(msg, "http://218.25.171.112:9200/app/device.apk", {
        // QRCode.toCanvas(msg, "http://10.200.0.11:8896/app/device.apk", {
          width: 148,
          height: 148,
          margin: 1
        }, function(error) {
          //console.log(error);
        });
      },
			getColors() {
				Request.getColors().then((response) => {
					const data = response.data;
					if (data.code == "1") {
						let color = {};
						for (let i in data.data) {
							color[data.data[i].status] = data.data[i];
						}
						this.$store.commit('setColor', color);
					} else {
						utils.messageAlert(data.data.msg, this.$t('label_717'), this.$t('label_100'));
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			getCookie(cookie) {
				let arr = cookie.split('; '),
					obj = {};
				for (let i = 0; i < arr.length; i++) {
					let c = arr[i].split('=');
					let key = decodeURIComponent(c[0]),
						value = decodeURIComponent(c[1]);
					obj[key] = value;
				}
				return obj;
			},
			login() {
        this.$store.commit('setLanguageName',this.languages);
        let languageType;
        if (this.languages=="1"){
          languageType = "chs";
          // loadLanguageAsync('chs')
        } else if (this.languages=="2"){
          languageType = "ja";
          // loadLanguageAsync('ja')
        } else if (this.languages=="3"){
          languageType = "en";
          // loadLanguageAsync('en')
        }
        sessionStorage.setItem("languageType", languageType);
        const data = {
					username: this.username,
					password: this.password,
          languageType: languageType
				};
				/*this.$store.commit('setActiveMenu', '/static/spotCheckPage');  0
				this.$store.commit('setActiveName', '主页');
				this.$router.push({
				  path: '/static/spotCheckPage'
				});*/
				if (data.username == '') {
					utils.messageAlert(this.$t('input_66'), this.$t('label_717'), this.$t('label_100'));
					return;
				}
				if (data.password == '') {
					utils.messageAlert(this.$t('input_28'), this.$t('label_717'), this.$t('label_100'));
					return;
				}
				Request.Login(data).then((response) => {
					const data = response.data;
					if (data.code == "1" && data.data.res == "1") {
						localStorage.setItem('SessionId', data.data.SessionId)
						/*this.$store.commit('setRoleId', data.data.currentUser.roleId);*/
						this.$store.commit('setUserName', data.data.currentUser.name);
						this.$store.commit('setSessionIdChange', data.data.SessionId);
						this.$store.commit('setCurrentUser', data.data.currentUser);
						this.$store.commit('setSessionId', data.data.SessionId);
            // this.$store.commit('setVersions', this.versions); //#1:THK; 2: 三菱 3郯城
						// document.title = '设备运维管理系统';
						// this.$store.commit('setActiveMenu', '/static/home');
						// this.$store.commit('setActiveName', '主页');
						// this.$router.push({
						//   path: '/static/home'
						// });
						this.$store.commit('setMenu', data.data.menu);
						let menu = data.data.menu;
						// this.$store.commit('setUserId', data.data.currentUser.userId);
						// if (this.$store.getters.getVersions != 1) {
							if (menu.indexOf('1') >= 0) {
								this.$store.commit('setActiveMenu', '/static/taskMap');
								this.$store.commit('setActiveName', '状态监视');
								this.$router.push({
									path: '/static/taskMap'
								});
							} else if (menu.indexOf('3') >= 0) {
								this.$store.commit('setActiveMenu', '/static/fileFactory');
								this.$store.commit('setActiveName', '档案管理/设备厂商管理');
								this.$router.push({
									path: '/static/fileFactory'
								});
							} else if (menu.indexOf('8') >= 0) {
								this.$store.commit('setActiveMenu', '/static/deviceTypePage');
								this.$store.commit('setActiveName', '档案管理/设备类型管理');
								this.$router.push({
									path: '/static/deviceTypePage'
								});
							} else if (menu.indexOf('32') >= 0) {
								this.$store.commit('setActiveMenu', '/static/deviceFilePage');
								this.$store.commit('setActiveName', '档案管理/设备档案');
								this.$router.push({
									path: '/static/deviceFilePage'
								});
							} else if (menu.indexOf('37') >= 0) {
								this.$store.commit('setActiveMenu', '/static/spotCheckPage');
								this.$store.commit('setActiveName', '点检管理/点检计划');
								this.$router.push({
									path: '/static/spotCheckPage'
								});
							} else if (menu.indexOf('41') >= 0) {
								this.$store.commit('setActiveMenu', '/static/spotResumePage');
								this.$store.commit('setActiveName', '点检管理/点检履历');
								this.$router.push({
									path: '/static/spotResumePage'
								});
							} else if (menu.indexOf('42') >= 0) {
								this.$store.commit('setActiveMenu', '/static/spotCountPage');
								this.$store.commit('setActiveName', '点检管理/点检统计');
								this.$router.push({
									path: '/static/spotCountPage'
								});
							} else if (menu.indexOf('45') >= 0) {
								this.$store.commit('setActiveMenu', '/static/organization');
								this.$store.commit('setActiveName', '基础信息/组织结构');
								this.$router.push({
									path: '/static/organization'
								});
							} else if (menu.indexOf('54') >= 0) {
								this.$store.commit('setActiveMenu', '/static/userPage');
								this.$store.commit('setActiveName', '基础信息/用户管理');
								this.$router.push({
									path: '/static/userPage'
								});
							} else if (menu.indexOf('59') >= 0) {
								this.$store.commit('setActiveMenu', '/static/timePage');
								this.$store.commit('setActiveName', '基础信息/时间管理');
								this.$router.push({
									path: '/static/timePage'
								});
							} else if (menu.indexOf('60') >= 0) {
								this.$store.commit('setActiveMenu', '/static/riskPage');
								this.$store.commit('setActiveName', '基础信息/风险内容管理');
								this.$router.push({
									path: '/static/riskPage'
								});
							} else if (menu.indexOf('64') >= 0) {
								this.$store.commit('setActiveMenu', '/static/dictPage');
								this.$store.commit('setActiveName', '基础信息/字典管理');
								this.$router.push({
									path: '/static/dictPage'
								});
							} else if (menu.indexOf('305') >= 0) {
								this.$store.commit('setActiveMenu', '/static/i18nPage');
								this.$store.commit('setActiveName', '基础信息/多语言设定');
								this.$router.push({
									path: '/static/i18nPage'
								});
							} else if (menu.indexOf('308') >= 0) {
								this.$store.commit('setActiveMenu', '/static/paramPage');
								this.$store.commit('setActiveName', '基础信息/参数设定');
								this.$router.push({
									path: '/static/paramPage'
								});
							} else if (menu.indexOf('68') >= 0) {
								this.$store.commit('setActiveMenu', '/static/warningTimePage');
								this.$store.commit('setActiveName', '基础信息/预警时间管理');
								this.$router.push({
									path: '/static/warningTimePage'
								});
							// } else if (menu.indexOf('12138') > 0) {
              //   this.$store.commit('setActiveMenu', '/static/customerPage');
              //   this.$store.commit('setActiveName', '基础信息/客户管理');
              //   this.$router.push({
              //     path: '/static/customerPage'
              //   });
              } else if (menu.indexOf('106') > 0) {
                this.$store.commit('setActiveMenu', '/static/maintainPlanPage');
                this.$store.commit('setActiveName', '保养维护/保养计划');
                this.$router.push({
                  path: '/static/maintainPlanPage'
                });
              } else if (menu.indexOf('119') > 0) {
                this.$store.commit('setActiveMenu', '/static/maintainResumePage');
                this.$store.commit('setActiveName', '保养维护/保养履历');
                this.$router.push({
                  path: '/static/maintainResumePage'
                });
              } else if (menu.indexOf('122') > 0) {
                this.$store.commit('setActiveMenu', '/static/maintainCountPage');
                this.$store.commit('setActiveName', '保养维护/保养统计');
                this.$router.push({
                  path: '/static/maintainCountPage'
                });
              } else if (menu.indexOf('171') > 0) {
                this.$store.commit('setActiveMenu', '/static/EquipmentInspection');
                this.$store.commit('setActiveName', '定期巡检/设备巡检');
                this.$router.push({
                  path: '/static/EquipmentInspection'
                });
              } else if (menu.indexOf('177') > 0) {
                this.$store.commit('setActiveMenu', '/static/InspectionRecord');
                this.$store.commit('setActiveName', '定期巡检/巡检履历');
                this.$router.push({
                  path: '/static/InspectionRecord'
                });
              } else if (menu.indexOf('179') > 0) {
                this.$store.commit('setActiveMenu', '/static/InspectionStatistics');
                this.$store.commit('setActiveName', '定期巡检/巡检统计');
                this.$router.push({
                  path: '/static/InspectionStatistics'
                });
              } else if (menu.indexOf('153') > 0) {
                this.$store.commit('setActiveMenu', '/static/malfunctionRepairPage');
                this.$store.commit('setActiveName', '故障维修/故障维修');
                this.$router.push({
                  path: '/static/malfunctionRepairPage'
                });
              } else if (menu.indexOf('154') > 0) {
                this.$store.commit('setActiveMenu', '/static/malfunctionResumePage');
                this.$store.commit('setActiveName', '故障维修/维修履历');
                this.$router.push({
                  path: '/static/malfunctionResumePage'
                });
              } else if (menu.indexOf('155') > 0) {
                this.$store.commit('setActiveMenu', '/static/malfunctionCountPage');
                this.$store.commit('setActiveName', '故障维修/维修统计');
                this.$router.push({
                  path: '/static/malfunctionCountPage'
                });
              } else if (menu.indexOf('156') > 0) {
                this.$store.commit('setActiveMenu', '/static/malfunctionKnowledgePage');
                this.$store.commit('setActiveName', '故障维修/故障维修知识库');
                this.$router.push({
                  path: '/static/malfunctionKnowledgePage'
                });
              // } else if (menu.indexOf('') > 0) {
              //   this.$store.commit('setActiveMenu', '/static/malfunctionApprove');
              //   this.$store.commit('setActiveName', '审批管理/工单审批');
              //   this.$router.push({
              //     path: '/static/malfunctionApprove'
              //   });
              // } else if (menu.indexOf('') > 0) {
              //   this.$store.commit('setActiveMenu', '/static/malfunctionApproveView');
              //   this.$store.commit('setActiveName', '审批管理/工单查看');
              //   this.$router.push({
              //     path: '/static/malfunctionApproveView'
              //   });
              // } else if (menu.indexOf('') > 0) {
              //   this.$store.commit('setActiveMenu', '/static/causeStatistics');
              //   this.$store.commit('setActiveName', '统计分析/设备状态统计');
              //   this.$router.push({
              //     path: '/static/causeStatistics'
              //   });
              // } else if (menu.indexOf('') > 0) {
              //   this.$store.commit('setActiveMenu', '/static/equipmentDesign');
              //   this.$store.commit('setActiveName', '统计分析/设备故障统计');
              //   this.$router.push({
              //     path: '/static/equipmentDesign'
              //   });
              // } else if (menu.indexOf('') > 0) {
              //   this.$store.commit('setActiveMenu', '/static/faultStatistics');
              //   this.$store.commit('setActiveName', '统计分析/故障原因统计');
              //   this.$router.push({
              //     path: '/static/faultStatistics'
              //   });
              // } else if (menu.indexOf('') > 0) {
              //   this.$store.commit('setActiveMenu', '/static/maintenanceStatistics');
              //   this.$store.commit('setActiveName', '统计分析/维修工作量统计');
              //   this.$router.push({
              //     path: '/static/maintenanceStatistics'
              //   });
              } else if (menu.indexOf('133') > 0) {
                this.$store.commit('setActiveMenu', '/static/partInfo');
                this.$store.commit('setActiveName', '备件管理/备件信息');
                this.$router.push({
                  path: '/static/partInfo'
                });
              } else if (menu.indexOf('138') > 0) {
                this.$store.commit('setActiveMenu', '/static/locationManagement');
                this.$store.commit('setActiveName', '备件管理/仓库信息');
                this.$router.push({
                  path: '/static/locationManagement'
                });
              } else if (menu.indexOf('142') > 0) {
                this.$store.commit('setActiveMenu', '/static/Warehousing');
                this.$store.commit('setActiveName', '备件管理/备件入库');
                this.$router.push({
                  path: '/static/Warehousing'
                });
              } else if (menu.indexOf('143') > 0) {
                this.$store.commit('setActiveMenu', '/static/exwarehouse');
                this.$store.commit('setActiveName', '备件管理/备件出库');
                this.$router.push({
                  path: '/static/exwarehouse'
                });
              } else if (menu.indexOf('144') > 0) {
                this.$store.commit('setActiveMenu', '/static/outRecord');
                this.$store.commit('setActiveName', '备件管理/入出库记录');
                this.$router.push({
                  path: '/static/outRecord'
                });
              } else if (menu.indexOf('145') > 0) {
                this.$store.commit('setActiveMenu', '/static/stock');
                this.$store.commit('setActiveName', '备件管理/备件库存');
                this.$router.push({
                  path: '/static/stock'
                });
              } else if (menu.indexOf('146') > 0) {
                this.$store.commit('setActiveMenu', '/static/inventoryTask');
                this.$store.commit('setActiveName', '备件管理/盘点任务');
                this.$router.push({
                  path: '/static/inventoryTask'
                });
              } else if (menu.indexOf('147') > 0) {
                this.$store.commit('setActiveMenu', '/static/inventoryRecord');
                this.$store.commit('setActiveName', '备件管理/盘点记录');
                this.$router.push({
                  path: '/static/inventoryRecord'
                });
              } else if (menu.indexOf('400') > 0) {
                this.$store.commit('setActiveMenu', '/static/Dashboard');
                this.$store.commit('setActiveName', '设备运转/仪表盘');
                this.$router.push({
                  path: '/static/Dashboard'
                });
              } else if (menu.indexOf('401') > 0) {
                this.$store.commit('setActiveMenu', '/static/signalLamp');
                this.$store.commit('setActiveName', '设备运转/信号灯');
                this.$router.push({
                  path: '/static/signalLamp'
                });
              } else if (menu.indexOf('402') > 0) {
                this.$store.commit('setActiveMenu', '/static/quipmentMonitoring');
                this.$store.commit('setActiveName', '设备运转/设备监视');
                this.$router.push({
                  path: ''
                });
              } else if (menu.indexOf('407') > 0) {
                this.$store.commit('setActiveMenu', '/static/kpiStatistics');
                this.$store.commit('setActiveName', '设备运转/KPI统计');
                this.$router.push({
                  path: '/static/kpiStatistics'
                });
              } else if (menu.indexOf('411') > 0) {
                this.$store.commit('setActiveMenu', '/static/mobileAnalysis');
                this.$store.commit('setActiveName', '设备运转/稼动分析');
                this.$router.push({
                  path: '/static/mobileAnalysis'
                });
              // } else if (menu.indexOf('') > 0) {
              //   this.$store.commit('setActiveMenu', '');
              //   this.$store.commit('setActiveName', '');
              //   this.$router.push({
              //     path: ''
              //   });
              // } else if (menu.indexOf('') > 0) {
              //   this.$store.commit('setActiveMenu', '');
              //   this.$store.commit('setActiveName', '');
              //   this.$router.push({
              //     path: ''
              //   });
              // } else if (menu.indexOf('') > 0) {
              //   this.$store.commit('', '');
              //   this.$store.commit('', '');
              //   this.$router.push({
              //     path: ''
              //   });
              //   document.title = '设备运维管理系统_信号灯';
              }
						// }
						// else {
						// 	this.$store.commit('setActiveMenu', '/static/signalLamp');
						// 	this.$store.commit('setActiveName', '信号灯');
						// 	this.$router.push({
						// 		path: '/static/signalLamp'
						// 	});
						// 	document.title = '设备运维管理系统_信号灯';
						// }
						sessionStorage.setItem('store', JSON.stringify(this.$store.state))
					} else {
						utils.messageAlert(data.data.msg, this.$t('label_717'), this.$t('label_100'));
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			loginOut() {
				Request.LoginOut().then((response) => {
					sessionStorage.clear();
					this.$router.push({
						path: '/static/login'
					});
				}).catch((response) => {
					console.log(response)
				})
			},
			setCookie(cname, cvalue, exdays) {
				let d = new Date();
				d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
				let expires = "expires=" + d.toUTCString();
				document.cookie = cname + "=" + cvalue + "; " + expires;
			},
      setLanguage(){
        Request.setLanguage(3).then((response) => {
          /*const data = response.data;
          console.log(data)*/
        }).catch((response) => {
          console.log(response)
        })
      }
		},

		beforeCreate() {
      localStorage.setItem("LoginLanguage", 'ja');
      if (Glod) {
        if (Glod.BaseUrl != '' && Glod.BaseUrl != null && Glod.BaseUrl != undefined) {
          this.$store.commit('setPostUrl', Glod.BaseUrl);
        }
        if (Glod.Version > 0) {
          this.versions = Glod.Version;
          this.$store.commit('setVersions', Glod.Version);
        }
        if (Glod.AppDownloadURL != '' && Glod.AppDownloadURL != null && Glod.AppDownloadURL != undefined) {
          this.$store.commit('setAppDownloadURL', Glod.AppDownloadURL);
        }
        if (Glod.DownloadAppFlag >= 0) {
          this.$store.commit('setDownloadAppFlag', Glod.DownloadAppFlag);
        }
        if (Glod.LogoClass != '' && Glod.LogoClass != null && Glod.LogoClass != undefined) {
          this.$store.commit('setLogoClass', Glod.LogoClass);
        }
        if (Glod.ShowMap != undefined && Glod.ShowMap != null && Glod.ShowMap != '') {
          this.$store.commit('setShowMap', Glod.ShowMap);
        }
      }
      // 初始化
      const lang = store.getters.getLanguageName;
      if (lang=="1"){
        loadLanguageAsync('chs')
      }
      if (lang=="2"){
        loadLanguageAsync('ja')
      }
      if (lang=="3"){
        loadLanguageAsync('en')
      }
		},
    mounted() {
      this.getColors();
      this.username = localStorage.getItem("LoginName");
      loadLanguageAsync('ja')
      this.loading = true
      if (this.versions == 3) {
        this.cookie = this.getCookie(document.cookie)
        if (this.cookie.nameUser != null && this.cookie.wordPass != null && this.cookie.nameUser != '' && this.cookie.wordPass !=
          '' && this.cookie.nameUser != undefined && this.cookie.wordPass != undefined) {
          this.username = this.cookie.nameUser
          this.password = this.cookie.wordPass
          this.login();
        } else {
          // window.open('about:blank', '_self').close()
        }
        setInterval(() => {
          let date1 = new Date(this.cookie.time);
          let date2 = new Date();
          let dateDiff = date2.getTime() - date1.getTime();
          if (dateDiff<10000) {
            if (this.cookie != '') {
              let cookie = this.getCookie(document.cookie)
              this.cookie.time = cookie.time
              if (cookie.nameUser != null && cookie.wordPass != null && cookie.nameUser != '' && cookie.wordPass !=
                '' && cookie.nameUser != undefined && cookie.wordPass != undefined) {
                if (cookie.nameUser != this.cookie.nameUser) {
                  this.loginOut();
                  this.cookie = cookie
                  this.username = cookie.nameUser
                  this.password = cookie.wordPass
                  this.login();
                }
              } else {
                // window.open('about:blank', '_self').close()
              }
            } else {
              // window.open('about:blank', '_self').close()
            }
          }else{
            // this.setCookie('nameUser', "", -1);
            // this.setCookie('wordPass', "", -1);
            // window.open('about:blank', '_self').close()
          }

        }, 1000)
      }
      /* if (sessionStorage.getItem('store')) {
         this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem('store'))))
       }*/
      // this.username = "admin";
      // this.password = "admin";
      // this.login();
      this.$nextTick(() => {
        this.appQRCode();
      });
    }
  }
</script>

<style scoped>
	.login-background {
		position: absolute;
		width: 100%;
		height: 100%;
		background-repeat: no-repeat;
		background-size: 100% 100%;
	}

	.login-info {
		position: absolute;
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		background: url(../../assets/img/login/background.png) no-repeat;
		align-items: center;
		flex-wrap: nowrap;
		background-size: 100% 100%;
	}

	.login-form-background {
		position: relative;
		width: 905px;
		height: 510px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.login-form {
		height: 290px;
		width: 100%;
	}

	.login-block {}

	.login-title {
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 30px;
		font-weight: 600;
		margin-bottom: 60px;
	}

	.login-title img {
		width: 45px;
		height: 45px;
		margin-right: 12px;
	}

	.login-input {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.login-input .username {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-bottom: 32px;
		background-image: url(../../assets/img/login/username.png);
	}

	.login-input .password {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-bottom: 10px;
		background-image: url(../../assets/img/login/password.png);
	}

	.login-input input {
		width: 300px;
		height: 50px;
		padding-left: 40px;
		background-color: #ffffff;
		background-repeat: no-repeat;
		background-position: center left;
		background-position-x: 10px;
		background-size: 20px 20px;
		font-size: 18px;
		display: flex;
		align-items: center;
		border: 0;
		border-bottom: 1px solid #414A59;
		color: #000000;
	}

	input::-webkit-input-placeholder {
		/* WebKit browsers */
		color: #475061;
	}

	input:-moz-placeholder {
		/* Mozilla Firefox 4 to 18 */
		color: #475061;
	}

	input::-moz-placeholder {
		/* Mozilla Firefox 19+ */
		color: #475061;
	}

	input:-ms-input-placeholder {
		/* Internet Explorer 10+ */
		color: #475061;
	}

	.login-button {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		padding-top: 10px;
	}

	.login-button button {
		text-align: center;
		font-size: 18px;
		color: #FFFFFF;
		width: 300px;
		height: 40px;
		border: none;
		background: linear-gradient(to right, #3fb393, #3fb393);
		cursor: pointer;
		border-radius: 5px;
	}

	.bottom-text {
		font-size: 12px;
		color: #222223;
		position: absolute;
		width: 100%;
		height: 50px;
		bottom: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-wrap: wrap;
	}

	.bottom-text div {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.bottom-text a {
		font-size: 12px;
		color: #fff;
		text-decoration: none;
	}

  .right-qrcode-showbtn-background {
    position: absolute;
    width: 15px;
    height: 80px;
    background-color: #9c9c9c;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
  }

  .right-qrcode {
    padding: 10px;
    height: 200px;
    width: 200px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    position: absolute;
    right: 0;
    top: 415px;
    align-items: flex-start;
    background: rgba(255, 255, 255, 0.21);
  }
</style>



// WEBPACK FOOTER //
// src/pages/login/login.vue